import { Controller, useFormContext } from 'react-hook-form';

import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { MdInput } from '@ui/components/MdInput';

import styles from '@features/club/ui/ClubFormInput/ClubFormInput.module.css';

export function DescriptionInput() {
  const { control } = useFormContext<{ description: string }>();
  return (
    <FormRow>
      <FormLabel>Описание</FormLabel>
      <FormInput>
        <Controller
          name="description"
          control={control}
          render={({ field: { value, onChange, disabled } }) => (
            <MdInput
              className={styles.description}
              value={value}
              onChange={onChange}
              disabled={disabled}
            />
          )}
        />
      </FormInput>
    </FormRow>
  );
}
